import { EVENT_STATUS_FINALIZED, FETCH_TICKET_ORDER_BY_EVENT_FINALIZE_DESC } from '@ogsnetwork/opp-api-lib';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { api } from './api';
import { clearUserData, getNewStateByAttr, getNewStateById } from './entities';
import { fetchFantasyEvents } from './fantasyEvents';
import { applyPagedPreFetchState, applyPagedState, getOffsetAndLimit } from './utils/pagination';
const RESULTS_PER_PAGE = 20;
const initialState = {
    byEventId: {},
    byId: {},
    byPage: {},
    byStatus: {},
    hasNextPage: false,
    page: 0,
    status: 'init'
};
export const fetchTickets = createAsyncThunk('tickets/fetch', async (options, thunkApi) => {
    try {
        return await (await api.instance).fetchTickets(options);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const fetchAllPropEventTickets = () => {
    var _a;
    const previousDaysFilterValue = moment()
        .utc()
        .subtract((_a = api.configuration) === null || _a === void 0 ? void 0 : _a.tickets.finalizedPreviousDaysRange, 'days')
        .format('YYYY-MM-DD');
    const options = {
        eventFinalizeTsGte: previousDaysFilterValue,
        gameType: 'prop_stake'
    };
    return fetchTickets(options);
};
export const fetchFinalizedPropTicketsPage = createAsyncThunk('tickets/fetch/page', async (page, thunkApi) => {
    const options = Object.assign(Object.assign({}, getOffsetAndLimit(page, RESULTS_PER_PAGE)), { gameType: 'prop_stake', orderBy: FETCH_TICKET_ORDER_BY_EVENT_FINALIZE_DESC, eventStatus: EVENT_STATUS_FINALIZED });
    try {
        return await (await api.instance).fetchTickets(options);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const purchasePropBetTicket = createAsyncThunk('tickets/propBet/purchase', async (options, thunkApi) => {
    try {
        return await (await api.instance).purchasePropBetsTicket(options.selections, options.eventId);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const editPropBetTicket = createAsyncThunk('tickets/propBet/edit', async (options, thunkApi) => {
    try {
        return await (await api.instance).editPropBetsTicketSelections(options.ticketId, options.deletedSelectionIds, options.newSelections);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export function isTicketFulfilledAction(action) {
    return action.type.startsWith('tickets/') && action.type.endsWith('/fulfilled');
}
function isRejectedAction(action) {
    return action.type.startsWith('tickets/') && action.type.endsWith('/rejected');
}
const applyTicketState = (state, tickets) => {
    state.byId = getNewStateById(state.byId, tickets);
    state.byEventId = getNewStateByAttr(state.byId, 'eventId');
    state.byStatus = getNewStateByAttr(state.byId, 'status');
};
const ticketsSlice = createSlice({
    name: 'tickets',
    initialState,
    reducers: {
        clearTicketErrors: (state) => {
            state.error = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(clearUserData.fulfilled, (state) => (state = initialState))
            .addCase(fetchFinalizedPropTicketsPage.fulfilled, (state, action) => {
            const page = action.meta.arg;
            applyPagedState(state, action.payload.tickets, page, RESULTS_PER_PAGE);
            state.status = 'success';
        })
            .addCase(fetchFantasyEvents.fulfilled, (state, action) => {
            if (action.payload.tickets) {
                applyTicketState(state, action.payload.tickets);
            }
        })
            .addCase(fetchTickets.pending, (state) => {
            state.status = 'fetching';
        })
            .addCase(fetchFinalizedPropTicketsPage.pending, (state) => {
            applyPagedPreFetchState(state);
            state.status = 'fetching';
        })
            .addCase(purchasePropBetTicket.fulfilled, (state, action) => {
            applyTicketState(state, [action.payload]);
            state.status = 'success';
        })
            .addCase(purchasePropBetTicket.pending, (state) => {
            state.status = 'purchasing';
        })
            .addCase(editPropBetTicket.fulfilled, (state, action) => {
            state.status = 'success';
            action.meta.arg.deletedSelectionIds.forEach((selectionId) => delete state.byId[selectionId]);
        })
            .addCase(editPropBetTicket.pending, (state) => {
            state.status = 'editing';
        })
            .addMatcher(isTicketFulfilledAction, (state, action) => {
            if (typeof action.payload.tickets !== 'undefined') {
                applyTicketState(state, action.payload.tickets);
            }
            state.status = 'success';
        })
            .addMatcher(isRejectedAction, (state, action) => {
            state.error = action.payload;
            state.status = 'error';
        });
    }
});
export const clearTicketErrors = ticketsSlice.actions.clearTicketErrors;
export const ticketsReducer = ticketsSlice.reducer;
